import request from '@/utils/request'
import qs from 'qs'

export function getIndex(){
    return request({
        url:'/site/index',
        method:'post',
    })
}

export function getArtist(id){
    let data ={
        id
    }
    return request({
        url:'/artist/index',
        method:'post',
        data:qs.stringify(data)
    })
}

export function getArtistList(){
    return request({
        url:'/artist/get-list',
        method:'post'
    })
}

export function getArtProduct(id ,keyword){
    let data = {
        id,
        keyword
    }
    return request({
        url:'/artist/get-product-list',
        method:'post',
        data:qs.stringify(data)
    })
}

export function getProduct( id ){
    let data = {
        id
    }
    return request({
        url:'/product/index',
        method:'post',
        data:qs.stringify(data)
    })
}
export function getDisplay(  ){
    return request({
        url:'/site/get-display',
        method:'post'
    })
}
export function verifyPassword( password ){
    let data = {
        password
    }
    return request({
        url:'site/verify-password',
        method:'post',
        data:qs.stringify(data)
    })
}
export function getMiniAppUrl(){
    return request({
        url:'/product/get-url-scheme',
        method:'post'
    })
}